;
define("cart_confirmation_modal.tpl", function(){});

